var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ flex: true, 'justify-between': true, group: true, relative: _vm.isBeingEdited },attrs:{"id":_vm.domCommentId}},[(_vm.isBeingEdited && !_vm.isPhone)?_c('div',{class:[
      'absolute',
      '-inset-x-1.5',
      '-top-1.5',
      'bottom-9',
      _vm.isUsedInPostExpandedView ? 'bg-transparent pointer-events-none' : 'z-underneath',
      'rounded-xl',
      'border-solid',
      'border-2',
      _vm.isDark ? 'bg-dark-ui-100 border-canary-500' : 'bg-light-ui-100 border-grape-500' ],attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex flex-col justify-between flex-grow min-w-0"},[_c('div',{staticClass:"flex flex-row"},[_c('div',{class:['flex flex-shrink-0', _vm.isUsedInPostExpandedView ? 'me-4' : 'me-2']},[(!_vm.author.registered)?_c('avatar-image',{attrs:{"user":_vm.author,"width":_vm.isStream || _vm.isUsedInPostExpandedView ? 20 : 16,"height":_vm.isStream || _vm.isUsedInPostExpandedView ? 20 : 16}}):_vm._e(),_vm._v(" "),(_vm.author.registered)?_c('a',{staticClass:"flex",attrs:{"target":"_blank","href":_vm.author.profile_url}},[_c('avatar-image',{attrs:{"user":_vm.author,"width":_vm.isStream || _vm.isUsedInPostExpandedView ? 20 : 16,"height":_vm.isStream || _vm.isUsedInPostExpandedView ? 20 : 16}})],1):_vm._e()],1),_vm._v(" "),_c('div',{class:[
          'font-semibold ltr:mr-1 rtl:ml-1 truncate',
          _vm.isStream ? 'leading-5 text-14' : 'text-12-16',
          {
            'text-dark-text-100': !_vm.isDark,
            'text-light-text-100': _vm.isDark,
          } ]},[(!_vm.author.registered)?_c('span',[_vm._v(_vm._s(_vm.authorName))]):_vm._e(),_vm._v(" "),(_vm.author.registered)?_c('a',{class:['text-current', _vm.isStream ? 'text-14' : 'text-body-extra-small'],attrs:{"href":_vm.author.profile_url,"target":"_blank"}},[_vm._v(_vm._s(_vm.authorName))]):_vm._e()]),_vm._v(" "),_c('relative-time',{class:{
          'flex-shrink-0': true,
          'text-14': _vm.isStream,
          'text-body-extra-small': !_vm.isStream,
          'text-dark-text-200': !_vm.isDark,
          'text-light-text-200': _vm.isDark,
        },attrs:{"datetime":_vm.comment.created_at || new Date().toISOString(),"dateformat":"short"}})],1),_vm._v(" "),(!_vm.isBeingEdited || _vm.isPhone)?_c('div',{class:[
        'wish-comment-content',
        'break-words',
        'mt-0.5',
        _vm.isUsedInPostExpandedView
          ? {
              'ms-9 me-4.75': true,
            }
          : {
              'ms-7': _vm.isStream,
              'ms-6': !_vm.isStream,
            },
        {
          'text-14': _vm.isStream && !_vm.isUsedInPostExpandedView,
          'text-12-16': !_vm.isStream && !_vm.isUsedInPostExpandedView,
          'text-body-small-posts': _vm.isUsedInPostExpandedView,
        },
        {
          'text-dark-text-100': !_vm.isDark,
          'text-light-text-100': _vm.isDark,
        } ],staticStyle:{"word-break":"break-word"},domProps:{"innerHTML":_vm._s(_vm.hyperlinkedBody)}}):_vm._e(),_vm._v(" "),(_vm.isBeingEdited && !_vm.isPhone)?_c('div',{class:[_vm.isUsedInPostExpandedView ? 'mt-0.5 ms-9 me-4.75' : 'mt-0.5 ms-6']},[_c('multiline-input',{ref:"editCommentInput",class:[
          {
            'tablet-portrait:mb-5': true,
            'ms-1': _vm.isStream,
          },
          'font-sans h-4 transition-none',
          {
            'text-14 leading-4': _vm.isStream && !_vm.isUsedInPostExpandedView,
            'text-body-extra-small leading-4': !_vm.isStream && !_vm.isUsedInPostExpandedView,
            'text-body-small-posts': _vm.isUsedInPostExpandedView,
          },
          {
            'placeholder-dark-text-200 text-dark-text-100': !_vm.isDark,
            'placeholder-light-text-200 text-light-text-100': _vm.isDark,
          } ],attrs:{"dir":_vm.dir,"auto-height":false,"autofocus":""},on:{"enter":_vm.submitEdit,"input":_vm.updateInlineCommentInputLastTypedInMs},nativeOn:{"paste":function($event){$event.stopPropagation();}},model:{value:(_vm.editingDraftBody),callback:function ($$v) {_vm.editingDraftBody=$$v},expression:"editingDraftBody"}}),_vm._v(" "),(!_vm.isPhone)?_c('div',{staticClass:"flex space-x-2 rtl:space-x-reverse justify-end ltr:-mr-1.5 rtl:-ml-1.5"},[_c('OzContainedButton',{attrs:{"size-preset":_vm.OzContainedButtonSizePreset.H24px,"color-scheme":_vm.OzContainedButtonColorScheme.SecondaryClear,"dark-mode":_vm.isDark,"text":_vm.__('Cancel')},on:{"click":function($event){return _vm.$emit('stop-editing')}}}),_vm._v(" "),_c('OzContainedButton',{attrs:{"size-preset":_vm.OzContainedButtonSizePreset.H24px,"dark-mode":_vm.isDark,"text":_vm.__('Update')},on:{"click":_vm.submitEdit}})],1):_vm._e()],1):_vm._e()]),_vm._v(" "),(_vm.showActions)?_c('OzTextButton',{class:[
      'absolute',
      // Reset browser default <button> styles
      'px-0',
      // DistanceFromParentEdgeToButtonEdge - DistanceFrom3DotsEdgeToIconEdge
      //   = 10px - (ButtonWidth - 3DotsWidth) / 2
      //   = 10px - (32px - 2px) / 2
      //   = -5px
      !_vm.isUsedInPostExpandedView && '-end-1.25',
      // In expanded view:
      //   = 7px - (ButtonWidth - 3DotsWidth) / 2
      //   = 7px - (32px - 2px) / 2
      //   = -8px
      // But we do -7px here because to avoid the horizontal scrollbar on the
      // comments.
      _vm.isUsedInPostExpandedView && '-end-1.75',
      // Ensure at least a 32px * 32px touch area.
      'w-[32px]',
      'pb-4' ],attrs:{"color-scheme":_vm.OzTextButtonColorScheme.SecondaryMuted,"dark-mode":_vm.isDark,"title":_vm.__('Comment actions')},on:{"click":_vm.toggleDropdown}},[_c('OzIcon',{attrs:{"name":"more_vertical","size":16}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }